export default __webpack_public_path__ + "static/media/kim.c0e8b418.jpg";